var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ListingCategory, SCREEN_SIZE } from '../../classes/enums';
import { Router, NavigationEnd } from '@angular/router';
import { HasSubscriptions } from '../has-subscriptions';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { filter } from 'rxjs/operators';
import { CommunicationService } from '../../services/communication.service';
var FooterComponent = /** @class */ (function (_super) {
    __extends(FooterComponent, _super);
    function FooterComponent(_router, _domManipulationService, communicationService) {
        var _this = _super.call(this) || this;
        _this._router = _router;
        _this._domManipulationService = _domManipulationService;
        _this.communicationService = communicationService;
        _this.provinces = [];
        // Specifically for gallery desktop where on map view, the footer needs to be shown in mobile mode on desktop
        _this.shouldShowMobileVersion = false;
        _this.showCanadaLocations = false;
        _this.showSiteSections = false;
        _this.showLegal = false;
        _this.showCorporate = false;
        _this.currentYear = new Date().getFullYear();
        // Enums
        _this.ListingCategory = ListingCategory;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this._router.events
            .pipe(filter(function (e) { return e instanceof NavigationEnd; }))
            .subscribe(function (e) {
            _this.toggleDropdown();
            _this._domManipulationService.scrollToTop();
        }));
    };
    // TODO: add in nice animatinos like celso has for the desktop sub nav
    FooterComponent.prototype.toggleDropdown = function (category) {
        switch (category) {
            case 'canadaLocations': {
                this.showCanadaLocations = !this.showCanadaLocations;
                break;
            }
            case 'siteSections': {
                this.showSiteSections = !this.showSiteSections;
                break;
            }
            case 'legal': {
                this.showLegal = !this.showLegal;
                break;
            }
            case 'corporate': {
                this.showCorporate = !this.showCorporate;
                break;
            }
            default: {
                this.showCanadaLocations = false;
                this.showSiteSections = false;
                this.showLegal = false;
                this.showCorporate = false;
            }
        }
    };
    FooterComponent.prototype.openQuebecModal = function () {
        this.communicationService.notifications.showQuebecModal.next(true);
    };
    return FooterComponent;
}(HasSubscriptions));
export { FooterComponent };
